// extracted by mini-css-extract-plugin
export var banner_wrapper = "index-module--banner_wrapper--34bcc";
export var close_btn = "index-module--close_btn--85698";
export var content_main = "index-module--content_main--a236e";
export var content_wrapper = "index-module--content_wrapper--94748";
export var desc = "index-module--desc--9dbf5";
export var title = "index-module--title--b11a0";